import { FamilyPlanCheckAction } from '../actions/FamilyPlanCheckAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
  requestBody: {
    sectionId: "familyPlanCheck",
    steps: [
      {
        sequence: "0",
        offerContainerId: "",
        stepId: "familyPlanCheck",
        fields: [
          {
            name: "Error Code",
            value: ""
          },
          {
            name: "Description",
            value: ""
          }
        ],
        options: [
          {
            name: "family Plan Check",
            value: ""
          }
        ]
      }
    ]
  },
  familyPlanCheckResponse: {

  },
  getExternalIdResponse: {

  },
  redirectUrl: "",
}

const FamilyPlanCheckReducer = (state: any = initState, action: any) => {
  const { type } = action;
  const { payload } = action;
  var FamilyPlanValue = { ...state.requestBody.steps };

  switch (type) {
    case FamilyPlanCheckAction.FAMILY_PLAN_CHECK_SUCCESS:
      return { ...state, familyPlanCheckResponse: payload };

    case FamilyPlanCheckAction.GET_EXTERNAL_ID_SUCCESS:
      return { ...state, getExternalIdResponse: payload };

    case FamilyPlanCheckAction.FAMILY_PLAN_CHECK_DONE:
      FamilyPlanValue[0].fields[0].value = payload.ErrorCode;
      FamilyPlanValue[0].fields[1].value = payload.ErrorDescription;
      FamilyPlanValue[0].options[0].value = payload.planCheckValue;
      FamilyPlanValue[0].offerContainerId = payload.offerContainerId;
      return {...state, redirectUrl : payload.redirectUrl};

    case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
      let section = payload.sections.filter((section: any) => {
        return (section.sectionId === 'familyPlanCheck')
      });
      if (section.length > 0) {
        let numberTypeValue = section[0].steps[0].options[0];
        FamilyPlanValue[0].offerContainerId = section[0].steps[0].offerContainerId;
        FamilyPlanValue[0].options[0].value = numberTypeValue ? numberTypeValue.value : "";
      }
      return state;

    default:
      return state;
  }
}

export default FamilyPlanCheckReducer;